import React, { useEffect, useState } from 'react'
import { CustomDropdown, CustomPanel, ImportExcelFile, PageHeader } from '../../../../components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import {
  gerarComparativoDoPicking,
  gerarComparativoDoPickingEmExcel,
} from '../../../../services/api/https/picking/picking.http'

const newState = {
  selectedOption: '',
  selectedType: '',
  isComparing: false,
  fileContent: [],
}

function ComparativoPicking({ history, dispatch }) {
  const picking = history.location.state.picking

  // Hooks
  const [state, setState] = useState({ ...newState })

  useEffect(() => {
    if (state.isComparing) {
      if (state.fileContent.length <= 1) {
        dispatch(showMessageBox(null, 'Arquivo vazio'))
      } else {
        dispatch(showLoadingBox('Gerando o comparativo . . .', 'Aguarde'))
        if (state.selectedType === 0) {
          gerarComparativoDoPicking(picking.id, state.selectedOption, state.fileContent)
            .then(() => dispatch(showMessageBox('Comparativo gerado com sucesso')))
            .catch(e => dispatch(showMessageBox(null, e)))
            .finally(() => {
              dispatch(hideLoadingBox())
              setState(prev => ({
                ...prev,
                isComparing: false,
                fileContent: [],
              }))
            })
        } else if (state.selectedType === 1) {
          gerarComparativoDoPickingEmExcel(picking.id, state.selectedOption, state.fileContent)
            .then(() => dispatch(showMessageBox('Comparativo gerado com sucesso')))
            .catch(e => dispatch(showMessageBox(null, e)))
            .finally(() => {
              dispatch(hideLoadingBox())
              setState(prev => ({
                ...prev,
                isComparing: false,
                fileContent: [],
              }))
            })
        } else {
          dispatch(showMessageBox(null, 'Selecione um tipo para exportar a comparação.'))
        }
      }
    }
  }, [state.isComparing])
  // Render
  return (
    <>
      <PageHeader>
        Comparativo Picking: <b>{picking.name}</b>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-4">
              <CustomDropdown
                marginTop={20}
                label={'Comparar Com :'}
                options={[{ label: 'Lactalis - Mapa de Venda', value: 0 }]}
                value={state.selectedOption}
                onChange={value => setState({ ...state, selectedOption: value })}
              />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                marginTop={20}
                label={'Exportar como :'}
                options={[
                  { label: 'Em PDF', value: 0 },
                  { label: 'Em XLSX', value: 1 },
                ]}
                value={state.selectedType}
                onChange={value => setState({ ...state, selectedType: value })}
              />
            </div>
            <div className="p-col-2" style={{ marginTop: 34 }}>
              {state.selectedOption === 0 ? (
                <ImportExcelFile
                  label="Processar"
                  classes="btnImportar"
                  hasIcon={true}
                  onFileImported={content =>
                    setState({
                      ...state,
                      isComparing: true,
                      fileContent: content,
                    })
                  }
                />
              ) : null}
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

export default connect()(withRouter(ComparativoPicking))
